<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <h1>Media Files</h1>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-row justify="center" justify-sm="start">
          <v-col cols="auto">
            <v-card class="px-4" :to="{
              name: 'media.directory',
              params: { directory: 'Provider' }
            }">
              <v-card-title class="justify-center">
                <v-icon size="8rem" color="info lighten-2">folder</v-icon>
              </v-card-title>
              <v-card-text class="text-center headline">
                Providers
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="auto">
            <v-card class="px-4" :to="{
              name: 'media.directory',
              params: { directory: 'Location' }
            }">
              <v-card-title class="justify-center">
                <v-icon size="8rem" color="info lighten-2">folder</v-icon>
              </v-card-title>
              <v-card-text class="text-center headline">
                Locations
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MediaIndex',
};
</script>
